import { NomadLogo } from "@/components/Nav";

const Footer = () => (
  <footer className="border-t border-white/[0.06] py-16" data-testid="site-footer">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <NomadLogo size={52} />
          <p className="mt-6 text-[#8a8a8a] text-sm leading-relaxed max-w-sm">
            Nomad Capital is a private investment firm partnering with
            enduring businesses across pharmaceutical, healthcare, and
            outdoor markets.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#e65c00] mb-5">Focus</p>
          <ul className="text-sm text-[#a8a8a8] space-y-3">
            <li>Pharmaceutical</li>
            <li>Healthcare</li>
            <li>Outdoor</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[#e65c00] mb-5">Inquiries</p>
          <p className="text-sm text-[#a8a8a8] leading-relaxed">
            We review every inquiry and respond directly.
          </p>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row md:items-center justify-between gap-4">
        <p className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-[#555]">
          © {new Date().getFullYear()} Nomad Capital. All rights reserved.
        </p>
        <p className="text-[11px] text-[#555] max-w-xl leading-relaxed">
          This website does not constitute an offer to sell or a solicitation of an offer to purchase any security.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
